export class Rook {
  static getMoves(position, color, gameState) {
    const [x, y] = position;
    const moves = [];
    
    // Directions: up, down, left, right
    const directions = [
      [1, 0], [-1, 0], [0, 1], [0, -1]
    ];
    
    directions.forEach(([dx, dy]) => {
      let newX = x + dx;
      let newY = y + dy;
      
      while (newX >= 1 && newX <= 8 && newY >= 1 && newY <= 8) {
        const targetPos = [newX, newY];
        
        if (!gameState.isOccupied(targetPos)) {
          moves.push(targetPos);
        } else {
          if (gameState.getPieceColor(targetPos) !== color) {
            moves.push(targetPos);
          }
          break;
        }
        
        newX += dx;
        newY += dy;
      }
    });
    
    return moves;
  }
}